export default function getRandomString() {
  return Math.floor(Math.random() * 1e10)
    .toString(36)
    .substring(2);
}
